export default __webpack_public_path__ + "static/media/banner2.f55ca017.png";